
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObcPoiButton as ObcPoiButtonElement} from '@oicl/openbridge-webcomponents/dist/ar/building-blocks/poi-button/poi-button.js';
 
 
 

 
 export const ObcPoiButton = createComponent({
   react: React,
   tagName: 'obc-poi-button',
   elementClass: ObcPoiButtonElement,
   events: {
     
   }
  });
 
 